<script lang="ts" setup>
// @ts-expect-error JS library
import { useMq } from 'vue3-mq'
import { useLocaleThemePath } from '~/composables/locale'

const { height, width } = useWindowSize()
const { xs, sm } = useMq()
</script>

<template lang="pug">
section.certs__alpha
  KinesisContainer.certs__alpha__wrapper
    KinesisElement.certs__alpha__content(
      :strength="25"
      type="depth_inv"
    )
      h1 {{ $t('certs.alpha.title') }}
      article
        h2 {{ $t('certs.alpha.articles.course.title') }}
        p {{ $t('certs.alpha.articles.course.text-content') }}
      article
        h3 {{ $t('certs.alpha.articles.my-experience.title') }}
        p {{ $t('certs.alpha.articles.my-experience.text-content') }}
    KinesisElement.certs__alpha__image(
      :strength="-75"
      type="translate"
      axis="x"
    )
      figure
        NuxtImg(
          src="https://s3.rottigni.tech/public/documents/certifications/boolean_certification_compressed.webp"
          :height="height / 2"
          :width="width - (width / 3)"
          provider="custom"
          legacy-format="png"
          :quality="80"
          :alt="$t('certs.alpha.image.alt')"
          :title="$t('certs.alpha.image.title')"
          :aria-label="$t('certs.alpha.image.aria-label')"
          :longdesc="$t('certs.alpha.image.longdesc')"
          itemscope
          item-type="https://schema.org/ImageObject"
        )
        NuxtLink(
          :to="useLocaleThemePath('/certs/boolean')"
          :title="$t('components.pdf.anchor.title', { name: 'Boolean Academy' })"
          :aria-label="$t('components.pdf.anchor.aria-label', { name: 'Boolean Academy' })"
        ) {{ $t('misc.inspect') }}
        figcaption {{ $t('certs.alpha.image.figcaption') }} -
          time(datetime="2022-02-15") 2022-02-15
</template>

<style lang="sass" scoped>
.certs__alpha
  @apply w-full h-full flex-center
  .certs__alpha__wrapper
    @apply flex-center flex-col lg:flex-row gap-10
    .certs__alpha__content
      @apply w-full md:w-1/2 h-auto
      *
        @apply text-center lg:text-right
      h1
        @apply text-2xl xl:text-4xl mb-4 xl:mb-6 font-bold text-animated
      article
        h2, h3
          @apply text-xl text-secondary pb-1.5
        p
          @apply text-white text-xs xl:text-base
    .certs__alpha__image
      @apply w-full md:w-1/2 h-auto
      figure
        @apply flex-center flex-col relative
        img
          @apply w-auto h-auto max-h-[60vh] border-4 border-primary rounded-xl shadow-2xl object-contain
        a
          @apply absolute top-0 left-[50%] py-1 px-3 bg-dark-900 border-2 border-primary text-primary rounded-[50px] text-base
          transform: translate(-50%, -50%)
        figcaption
          @apply text-secondary text-sm mt-2 whitespace-nowrap
          time
            @apply ml-1 whitespace-nowrap font-bold
</style>
